import { Capacitor } from "@capacitor/core";
import { FirebaseAuthentication } from "@capacitor-firebase/authentication";
import {
  GoogleAuthProvider,
  signInWithCredential,
  OAuthProvider,
  updateProfile,
  linkWithCredential,
  signOut,
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  fetchSignInMethodsForEmail,
  EmailAuthProvider,
} from "firebase/auth";
import {
  query,
  doc,
  getDoc,
  updateDoc,
  getFirestore,
} from "firebase/firestore";
import { Purchases } from "@revenuecat/purchases-capacitor";

import { Dialog } from "@capacitor/dialog";
import { showToast } from "utils/utils";
/* import { crash, log } from "utils/crashlytics";*/
import { Toast } from "@capacitor/toast";

export const signInWithGoogle = async () => {
  // 1. Create credentials on the native layer

  const signInOptions = {
    customParameters: [{ key: "prompt", value: "select_account" }],
    skipNativeAuth: true,
  };

  const result = await FirebaseAuthentication.signInWithGoogle(
    signInOptions
  ).catch(function (error) {
    // Handle Errors here.

    let errorCode = error.code;
    console.log(error);
    return;
  });
  // 2. Sign in on the web layer using the id token

  const credential = GoogleAuthProvider.credential(result.credential?.idToken);

  const auth = getAuth();

  return await signInWithCredential(auth, credential)
    .then(function (response) {
      //log(response);
      return result?.additionalUserInfo?.isNewUser;
    })
    .catch(function (error) {
      //log(error);
      showToast(error);
      return error;
    });
};

export const linkWithGoogle = async () => {
  const db = getFirestore();

  // 1. Create credentials on the native layer
  const signInOptions = {
    customParameters: [{ key: "prompt", value: "select_account" }],
    skipNativeAuth: true,
  };

  const result = Capacitor.isNativePlatform()
    ? await FirebaseAuthentication.signInWithGoogle(signInOptions).catch(
        function (error) {
          console.log(error);
          return error;
        }
      )
    : await FirebaseAuthentication.linkWithGoogle(signInOptions).catch(
        function (error) {
          console.log(error);
          return error;
        }
      );
  // 2. Sign in on the web layer using the id token
  const credential = GoogleAuthProvider.credential(result.credential?.idToken);
  const auth = getAuth();
  let userDisplayName = result.additionalUserInfo?.profile?.name
    ? result.additionalUserInfo?.profile?.name
    : "Anonymous";
  let userPhoto = result.additionalUserInfo?.profile?.picture
    ? result.additionalUserInfo?.profile?.picture
    : "";
  let userEmail = result.user?.email;

  const colRef = query(doc(db, "users", auth?.currentUser?.uid));

  if (Capacitor.isNativePlatform()) {
    return await linkWithCredential(auth.currentUser, credential)
      .then(function (response) {
        let name = response?.user?.providerData[0]?.displayName;
        let photo = response?.user?.providerData[0]?.photoURL;
        let email = response?.user?.providerData[0]?.email;

        updateProfile(auth.currentUser, {
          displayName: name,
          photoURL: photo,
        })
          .then(() => {
            getDoc(doc(db, "users", auth?.currentUser?.uid)).then((docSnap) => {
              if (docSnap.exists()) {
                return updateDoc(colRef, {
                  name: name,
                  photo: photo,
                  email: email,
                });
              }
            });
          })
          .catch((error) => {
            console.log(error);
          });

        return response;
      })

      .catch(function (error) {
        console.log(error);
        return error;
      });
  } else {
    updateProfile(auth.currentUser, {
      displayName: userDisplayName,
      photoURL: userPhoto,
    }).then(() => {
      getDoc(doc(db, "users", auth?.currentUser?.uid)).then((docSnap) => {
        if (docSnap.exists()) {
          return updateDoc(colRef, {
            name: userDisplayName,
            photo: userPhoto,
            email: userEmail,
          });
        }
      });
    });
    return "done";
  }
};

export const linkWithApple = async () => {
  const db = getFirestore();

  const result = Capacitor.isNativePlatform()
    ? await FirebaseAuthentication.signInWithApple({
        scopes: ["name", "email"],
        skipNativeAuth: true,
      }).catch(function (error) {
        console.log(error);
        return error;
      })
    : await FirebaseAuthentication.linkWithApple({
        scopes: ["name", "email"],
        skipNativeAuth: true,
      }).catch(function (error) {
        console.log(error);
        return error;
      });

  //remove noname
  let userDisplayName = result.user?.displayName
    ? result.user?.displayName
    : "NoName";
  const provider = new OAuthProvider("apple.com");
  provider.addScope("email");
  provider.addScope("name");
  const credential = provider.credential({
    idToken: result.credential?.idToken,
    rawNonce: result.credential?.nonce,
  });

  const auth = getAuth();

  const colRef = query(doc(db, "users", auth?.currentUser?.uid));

  if (Capacitor.isNativePlatform()) {
    return await linkWithCredential(auth.currentUser, credential)
      .then(function (response) {
        //only update profile if this is a new user
        if (result.user?.displayName !== undefined) {
          updateProfile(auth.currentUser, {
            displayName: userDisplayName,
            // photoURL:
            //   "https://firebasestorage.googleapis.com/v0/b/oles-test-project.appspot.com/o/common%2Fanonymous.svg?alt=media&token=693cb2a9-ef9f-4842-b8af-7b4eacf3a0d8",
          })
            .then(() => {
              getDoc(doc(db, "users", auth?.currentUser?.uid)).then(
                (docSnap) => {
                  if (docSnap.exists()) {
                    return updateDoc(colRef, {
                      name: userDisplayName,
                    });
                  }
                }
              );
            })

            .catch((error) => {
              console.log(error);
            });
        }
        return response;
      })
      .catch(function (error) {
        console.log("error creating", error);

        return error;
      });
  } else {
    updateProfile(auth.currentUser, {
      displayName: userDisplayName,
      // photoURL:
      //   "https://firebasestorage.googleapis.com/v0/b/oles-test-project.appspot.com/o/common%2Fanonymous.svg?alt=media&token=693cb2a9-ef9f-4842-b8af-7b4eacf3a0d8",
    }).then(() => {
      getDoc(doc(db, "users", auth?.currentUser?.uid)).then((docSnap) => {
        if (docSnap.exists()) {
          return updateDoc(colRef, {
            name: userDisplayName,
          });
        }
      });
    });
    return "done";
  }
};

export const signInWithApple = async () => {
  const result = await FirebaseAuthentication.signInWithApple({
    scopes: ["name", "email"],
    skipNativeAuth: true,
  }).catch(function (error) {
    console.log(error);
    return error;
  });

  //remove noname
  let userDisplayName = result.user?.displayName
    ? result.user?.displayName
    : "NoName";
  const provider = new OAuthProvider("apple.com");
  provider.addScope("email");
  provider.addScope("name");
  const credential = provider.credential({
    idToken: result.credential?.idToken,
    rawNonce: result.credential?.nonce,
  });

  const auth = getAuth();
  return await signInWithCredential(auth, credential)
    .then(function (response) {
      //only update profile if this is a new user
      if (result.user?.displayName !== undefined) {
        updateProfile(auth.currentUser, {
          displayName: userDisplayName,
          // photoURL:
          //   "https://firebasestorage.googleapis.com/v0/b/oles-test-project.appspot.com/o/common%2Fanonymous.svg?alt=media&token=693cb2a9-ef9f-4842-b8af-7b4eacf3a0d8",
        })
          .then(() => {})
          .catch((error) => {
            console.log(error);
          });
      }
      return result?.additionalUserInfo?.isNewUser;
    })
    .catch(function (error) {
      console.log("error creating", error);

      return error;
    });
};

export const signOutFromApp = async () => {
  try {
    await Purchases.logOut();
    await FirebaseAuthentication.signOut();
    await signOut(getAuth());

    clearFirestoreCache();
  } catch (error) {
    console.log(error);
    alert(error);
  }
};

export const clearFirestoreCache = async () => {
  const map = window["_reactFirePreloadedObservables"];
  Array.from(map.keys()).forEach(
    (key) => key.includes("firestore") && map.delete(key)
  );
};

export const signInWithEmail = async (email, password) => {
  const auth = getAuth();
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (error) {
    Toast.show({
      text: "Failed to log in. Please try again",
      duration: 3000,
    });
  }
};

export const signUpWithEmail = async (email, password) => {
  const auth = getAuth();
  await createUserWithEmailAndPassword(auth, email, password);
};

export const checkIfEmailExists = async (email) => {
  const auth = getAuth();
  let emailExist = await fetchSignInMethodsForEmail(auth, email);
  return emailExist;
};
export const createNewEmailUsser = async (email, password) => {
  const auth = getAuth();
  return await createUserWithEmailAndPassword(auth, email, password);
};

export const sendSignInLinkToEmail = async (email) => {
  await FirebaseAuthentication.sendSignInLinkToEmail({
    email,
    actionCodeSettings: {
      // URL you want to redirect back to. The domain (www.example.com) for this
      // URL must be in the authorized domains list in the Firebase Console.
      url: "https://prediction.olelillebo.com/completeSignup",
      //url: "https://prediction.page.link/dhgB",
      //url: "https://oles-test-project.firebaseapp.com/completeSignup",

      // This must be true.
      handleCodeInApp: true,
      iOS: {
        bundleId: "com.olelillebo.prediction",
      },
      android: {
        packageName: "com.olelillebo.prediction",
        installApp: true,
        //minimumVersion: "12",
      },
      dynamicLinkDomain: "prediction.page.link",
    },
  });
  // The link was successfully sent. Inform the user.
  // Save the email locally so you don't need to ask the user for it again
  // if they open the link on the same device.
  window.localStorage.setItem("emailForSignIn", email);
};

export const signInWithEmailLink = async (emailLink) => {
  const { isSignInWithEmailLink } =
    await FirebaseAuthentication.isSignInWithEmailLink({
      emailLink,
    });
  if (!isSignInWithEmailLink) {
    return;
  }
  let email = window.localStorage.getItem("emailForSignIn");

  if (!email) {
    // User opened the link on a different device. To prevent session fixation
    // attacks, ask the user to provide the associated email again.
    const { value } = await Dialog.prompt({
      title: "Confirm email",
      message: `Please provide your email for confirmation.`,
    });
    email = value;
  }

  // The client SDK will parse the code from the link for you.
  const credential = EmailAuthProvider.credentialWithLink(email, emailLink);
  const auth = getAuth();
  const result = await signInWithCredential(auth, credential);
  const isNewUser = result._tokenResponse.isNewUser;

  window.localStorage.removeItem("emailForSignIn");
  return isNewUser;
};

export const sendPasswordResetEmail = async (email) => {
  await FirebaseAuthentication.sendPasswordResetEmail({
    email,
    actionCodeSettings: {
      url: "https://prediction.olelillebo.com/resetPassword",
      handleCodeInApp: true,
      iOS: {
        bundleId: "com.olelillebo.prediction",
      },
      android: {
        packageName: "com.olelillebo.prediction",
        installApp: true,
        //minimumVersion: "12",
      },
      dynamicLinkDomain: "prediction.page.link",
    },
  });
};

export const confirmPasswordReset = async (oobCode, newPassword) => {
  if (!oobCode && !newPassword) return;

  return await FirebaseAuthentication.confirmPasswordReset({
    oobCode,
    newPassword,
  });
};
